import { baseRequest } from './base'

// 设置 本地文件上传信息接口返回 提交
function commonUpload(params) {
  return baseRequest(`/api/pcWeb/common/upload`, 'post', params)
}

// 拿到学校端设置的基础信息
function getSchoolBaseInfo(params) {
  return baseRequest(`/api/pcWeb/accUser/getSchoolBaseInfo`, 'post', params)
}

// 设置保存确认按钮
function saveOneSchoolOneProject(params) {
  return baseRequest(
    `/api/pcWeb/accUser/saveOneSchoolOneProject`,
    'post',
    params
  )
}

// 通知与公告详情
function getNews(id) {
  return baseRequest(`/api/school/getNews/${id}`, 'get')
}
export default {
  commonUpload: commonUpload,
  getSchoolBaseInfo: getSchoolBaseInfo,
  saveOneSchoolOneProject: saveOneSchoolOneProject,
  getNews,
}
